









import { Component, Prop, Vue } from 'vue-property-decorator';
import HeaderNavbar from '@/components/Header/Navbar.vue';
import PlantView from '@/components/PlantView/index.vue';

@Component({
  components: {
    HeaderNavbar,
    PlantView
  }
})
export default class Plant extends Vue {
  @Prop([Number, String]) readonly id!: number | 'new';
}
